type TSortByName = (firstItem: { name: string }, secondItem: { name: string }) => number;

export const sortByName: TSortByName = (firstItem, secondItem) => (firstItem.name > secondItem.name ? 1 : -1);
